import { Calendar } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const enrollmentEventTypeOptions: ComboboxFilterOption<string>[] = [
  { label: 'ICHRA Invite', value: 'ichra_invite' },
  { label: 'Open Enrollment', value: 'open_enrollment' },
  { label: 'Special Enrollment', value: 'special_enrollment' },
]

const EnrollmentEventTypeFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = enrollmentEventTypeOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Enrollment Event Type', options: filteredOptions || [] }]}
        placeholder='Search enrollment types...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={enrollmentEventTypeOptions || []}
          noSelectionText='Enrollment Event Type'
          pluralIdentifier='enrollment event types'
        >
          <Calendar size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EnrollmentEventTypeFilter
